import {z} from 'zod'

import {
  CreateOrUpdateBlockDocumentHeaderDocument,
} from '@sdox/api'

import {EditorFeature} from '../../../../inputs/TipTap/types'
import {createFormConfig} from '../../utils/createFormConfig'
import {createMetaSchema} from '../../utils/getCreateMetaFromFieldValues'
import {i18nValidation} from '../../../../../i18n'

import type {
  BlockDocumentHeaderInput,
  CreateOrUpdateDocumentMutation,
} from '@sdox/api'

type Schema = z.infer<typeof validatorSchema>

const validatorSchema = z.object({
  data: z.object({
    title: z.string().min(1, {message: i18nValidation.enterText}),
    callout: z.string(),
  }),
  meta: createMetaSchema,
})

export const documentHeaderConfig = createFormConfig<
  Schema,
  CreateOrUpdateDocumentMutation,
  BlockDocumentHeaderInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockDocumentHeaderDocument,
  },
  validatorSchema,
  fieldMapper: (fieldValues) => ({
    title: fieldValues.data.title,
    callout: fieldValues.data.callout,
  }),
  inputFields: [
    {
      label: 'Titel',
      fieldName: 'data.title',
      inputType: 'richtext',
      editorConfig: {
        isSmall: true,
        spanAsParagraph: true,
        features: [
          EditorFeature.paragraph,
          EditorFeature.nobreak,
          EditorFeature.footnote,
        ],
      },
      defaultValue: '',
      required: true,
      placeholder: 'Titel',
    },
    {
      label: 'Callout',
      fieldName: 'data.callout',
      inputType: 'text',
      defaultValue: '',
      required: false,
      placeholder: 'Callout',
    },
  ],
})
